import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-unsaved-changes-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule],
  template: `
    <p-dialog header="Unsaved Changes" [(visible)]="visible" [modal]="true" [closable]="false" [style]="{ width: '30vw' }" [baseZIndex]="10000">
      <p>You have unsaved changes. Are you sure you want to leave this page?</p>

      <ng-template pTemplate="footer">
        <button pButton label="No" class="p-button" (click)="confirm(false)"></button>
        <button pButton label="Yes" class="p-button" (click)="confirm(true)"></button>
      </ng-template>
    </p-dialog>
  `
})
export class UnsavedChangesDialogComponent {
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() decision = new EventEmitter<boolean>();

  confirm(value: boolean) {
    this.visible = false;
    this.visibleChange.emit(this.visible);
    this.decision.emit(value);
  }
}
